<template>
    <component :is="layout" />
</template>
<script>
export default {
    name    : "App",
    computed: {
        layout() {
            const layout = typeof undefined !== typeof this.$route.meta.layout ? this.$route.meta.layout : "private";

            return () => import(`@/layouts/${layout}.vue`);
        }
    }
};
</script>
